export default "__VITE_ASSET__Ci8N6xNU__"